import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-close-opportunity',
  imports: [CommonModule, FormsModule],
  templateUrl: './mdl-close-opportunity.html',
  styleUrl: './mdl-close-opportunity.css'
})
export class MdlCloseOpportunity implements OnInit{
  private api = inject(Api);

  public motivo: string = '';
  public comentarios: string = '';
  public status: any = [];
  public statusSlc: string = '';

  constructor(
    public mdl: MatDialogRef<MdlCloseOpportunity>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

  }

  ngOnInit(): void {
      this.api.getStatusByType({tipo: 'OPP'}).subscribe({
        next: (data: any) => {
          this.status = data.data;
          this.status = this.status.filter((s: any) => s.nombre.toLowerCase().includes('cerrada'));
          console.log(this.status);
        },
        error: (error) => {
          console.error('Error fetching status:', error);
        },
      });
  }

  closeMdl(){
    this.mdl.close(); 
  }

  closeOpportunity(){
    console.log('Datos enviados:', {
      oportunidad_id: this.data.oportunidad_id,
      id_estado: this.statusSlc
    });
    this.api.updateOpportunityStatus({
      oportunidad_id: this.data.oportunidad_id,
      id_estado: this.statusSlc
    }).subscribe({
      next: (data: any) => {
        console.log('Oportunidad cerrada:', data);
        this.mdl.close(true); 
      },
      error: (error) => {
        console.error('Error closing opportunity:', error);
      },
    });
  }

  readStatus(){
    console.log('Estado seleccionado:', this.statusSlc);
  }
}
